import config from 'config';

import { Box, Flex, Grid, GridItem, Text, useTheme } from '@chakra-ui/react';

import { PackageItem } from 'types';

import { ContentLoader } from 'components/ContentLoader';
import { CustomScrollBar } from 'components/CustomScrollBar';
import { SubPackageItem } from '../SubPackageItem';

const {
  myPackages: { emptyMessage }
} = config;

interface PackagesListProps {
  items: PackageItem[];
  isLoading: boolean;
}

const SubPackagesList = ({ items, isLoading }: PackagesListProps) => {
  const {
    colors: {
      palette: {
        dashboard: {
          packages: {
            packagePage: { subPackageList }
          }
        }
      }
    }
  } = useTheme();

  const isItemsExist = items?.length;

  return (
    <Box
      position='relative'
      bg={subPackageList.containerBg}
      mx={{ base: '-15px', sm: 0 }}
      borderRadius={{ base: 0, sm: 6 }}
      alignSelf='stretch'
      overflow='hidden'
    >
      <Grid
        templateColumns='repeat(6, 1fr)'
        px='20px'
        py='9px'
        columnGap='10px'
        bg={subPackageList.headerBg}
      >
        <GridItem colSpan={{ base: 6, lg: 3 }}>
          <Flex h='100%' alignItems='center' justifyContent='start'>
            <Text
              fontSize='13px'
              lineHeight='140%'
              textTransform='uppercase'
              color={subPackageList.headerTextColor}
            >
              Items
            </Text>
          </Flex>
        </GridItem>
        <GridItem display={{ base: 'none', lg: 'block' }} colSpan={1}>
          <Flex h='100%' alignItems='center' justifyContent='center' px='15px'>
            <Text
              fontSize='13px'
              lineHeight='140%'
              textTransform='uppercase'
              color={subPackageList.headerTextColor}
            >
              QTY
            </Text>
          </Flex>
        </GridItem>

        <GridItem display={{ base: 'none', lg: 'block' }} colSpan={1}>
          <Flex h='100%' alignItems='center' justifyContent='center'>
            <Text
              fontSize='13px'
              lineHeight='140%'
              textTransform='uppercase'
              color={subPackageList.headerTextColor}
            >
              Used
            </Text>
          </Flex>
        </GridItem>
        <GridItem display={{ base: 'none', lg: 'block' }} colSpan={1}>
          <Flex h='100%' alignItems='center' justifyContent='center'>
            <Text
              fontSize='13px'
              lineHeight='140%'
              textTransform='uppercase'
              color={subPackageList.headerTextColor}
            >
              Remaining
            </Text>
          </Flex>
        </GridItem>
      </Grid>

      <Box bg={subPackageList.containerBg} position='relative'>
        {isItemsExist ? (
          <CustomScrollBar maxHeight='353px'>
            {items.map((packageItem, index) => {
              const isLastItem = index === items.length - 1;

              return (
                <SubPackageItem
                  key={packageItem.svc_num}
                  item={packageItem}
                  isLastItem={isLastItem}
                />
              );
            })}
          </CustomScrollBar>
        ) : (
          <ContentLoader
            bg={subPackageList.containerBg}
            label={emptyMessage}
            minHeight={{ base: '80px', md: '150px' }}
            isLoading={isLoading}
          />
        )}
      </Box>
    </Box>
  );
};

export default SubPackagesList;
